import TransactionsProgressive from './transaction-progressive';

export default TransactionsProgressive;
